import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-045c03cc")

_pushScopeId("data-v-045c03cc")
const _hoisted_1 = { class: "p-a spread bg-white pt-16 px-32 z-1" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "wedge",
  style: {"height":"48px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "wedge",
  style: {"height":"40px"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Pic, {
      src: "logo_&_text",
      width: "126",
      height: "32"
    }),
    _hoisted_2,
    _createVNode(_component_t, {
      as: "p",
      path: "tradingexperience_2"
    }),
    _hoisted_3,
    _createVNode("button", {
      class: "btn block rookie",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tag(0)))
    }, [
      _createVNode(_component_t, { path: "tradingexperience_3" })
    ]),
    _createVNode("button", {
      class: "btn block mt-24 veteran",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tag(1)))
    }, [
      _createVNode(_component_t, { path: "tradingexperience_4" })
    ])
  ]))
})